export default __webpack_public_path__ + "static/media/sinsoftheflesh.1fb8940d.png";